// frontend/src/components/common/RoleSelectionModal.jsx
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './RoleSelectionModal.css';

const RoleSelectionModal = ({ isOpen, onClose, onSelect, mode = 'register' }) => {
  if (!isOpen) return null;

  const isRegisterMode = mode === 'register';
  const title = isRegisterMode ? "Créer un compte" : "Se connecter";
  const subtitle = isRegisterMode ? "Je souhaite m'inscrire en tant que :" : "Je me connecte en tant que :";
  const buttonText = isRegisterMode ? "S'inscrire" : "Se connecter";

  const roles = [
    {
      type: 'partner',
      title: 'Partenaire',
      description: isRegisterMode 
        ? 'Vendez vos services, acceptez les paiements internationaux'
        : 'Accédez à votre espace partenaire',
      icon: 'fas fa-building',
      color: 'blue',
      features: isRegisterMode 
        ? ['Accepter des paiements Stripe', 'Créer des packs B2C', 'API sécurisée']
        : ['Gérer vos services', 'Voir vos ventes', 'Configurer vos packs']
    },
    {
      type: 'client',
      title: 'Client',
      description: isRegisterMode
        ? 'Achetez des points, utilisez des services internationaux'
        : 'Accédez à votre espace client',
      icon: 'fas fa-user',
      color: 'green',
      features: isRegisterMode
        ? ['Acheter des points', 'Utiliser des services', 'Suivre votre consommation']
        : ['Voir vos points', 'Acheter des packs', 'Historique des transactions']
    }
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div 
          className="role-modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div 
            className="role-modal-container"
            initial={{ scale: 0.9, y: 30 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.9, y: 30 }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="role-modal-header">
              <div className="role-modal-icon">
                <i className="fas fa-question-circle"></i>
              </div>
              <h2>{title}</h2>
              <p>{subtitle}</p>
              <button className="role-modal-close" onClick={onClose}>
                <i className="fas fa-times"></i>
              </button>
            </div>

            <div className="role-modal-body">
              <div className="roles-grid">
                {roles.map((role) => (
                  <motion.div
                    key={role.type}
                    className={`role-card ${role.color}`}
                    whileHover={{ y: -8, scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => onSelect(role.type)}
                  >
                    <div className={`role-icon ${role.color}`}>
                      <i className={role.icon}></i>
                    </div>
                    <h3>{role.title}</h3>
                    <p>{role.description}</p>
                    <ul className="role-features">
                      {role.features.map((feature, idx) => (
                        <li key={idx}>
                          <i className="fas fa-check-circle"></i>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                    <button className={`role-btn ${role.color}`}>
                      {buttonText} en tant que {role.title}
                      <i className="fas fa-arrow-right"></i>
                    </button>
                  </motion.div>
                ))}
              </div>
            </div>

            <div className="role-modal-footer">
              <p>
                {isRegisterMode ? "Vous avez déjà un compte ?" : "Vous n'avez pas de compte ?"}
              </p>
              <button 
                className="login-link" 
                onClick={() => {
                  if (isRegisterMode) {
                    onSelect('login');
                  } else {
                    onSelect('register');
                  }
                }}
              >
                {isRegisterMode ? "Se connecter" : "Créer un compte"}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default RoleSelectionModal;